import { createAsyncThunk } from '@reduxjs/toolkit';
import { ref, get } from 'firebase/database';
import { database } from '../../config';

export const fetchCourse = createAsyncThunk(
  'userData/fetchCourse',
  async (courseId, { rejectWithValue }) => {
    const courseRef = ref(database, `public_courses/${courseId}`);
    try {
      const snapshot = await get(courseRef);
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return rejectWithValue('Course not found');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
